export const alert = {
    namespaced: true,
    state() { return {
        alerts: [],
    }},
    getters: {
        get_alerts: (state) => state.alerts.reduce((acc, item) => acc.some(element => item.message == element.message)? acc: [...acc, item], []),
    },
    actions: {
        alerts(store, payload) {
            store.commit('alerts', payload);
        },
        clear({commit}) {
            commit('clear');
        }
    },
    mutations: {
        alerts(state, payload) {
          // Создаём уникальный id для алерта, чтобы потом знать, какой алерт нужно удалить из массива
          payload.id = Date.now().toString(36) + Math.random().toString(36).substring(2);
          const { timer = 15000 } = payload;
          state.alerts.push(payload);
          setTimeout(() => {
            const alertIndex = state.alerts.findIndex(alert => alert.id === payload.id);
            if (alertIndex !== -1) {
              state.alerts.splice(alertIndex, 1);
            }
          }, timer);
        },
        clear(state) {
            state.alerts = [];
        }
    }
}
